var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMagnifier(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 40,
    viewBox: "0 0 37 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "magnifier"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 104 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6291 27.2832C24.3755 26.8522 25.3299 27.108 25.7609 27.8544L32.0032 38.6664C32.4341 39.4128 32.1784 40.3672 31.432 40.7982C30.6856 41.2291 29.7311 40.9734 29.3002 40.227L23.0579 29.415C22.6269 28.6686 22.8827 27.7141 23.6291 27.2832Z",
    fill: "#1D1D38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 125",
    d: "M25.9848 28.6449C31.6504 24.2347 32.6681 16.0667 28.2579 10.4012C23.8477 4.7356 15.6797 3.71791 10.0142 8.12808C4.34864 12.5383 3.33095 20.7062 7.74112 26.3718",
    stroke: "#1D1D38",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 120",
    cx: 13.2663,
    cy: 29.6498,
    r: 2.26503,
    fill: "#1D1D38"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifier);
export default __webpack_public_path__ + "static/media/magnifier.4a948cf0.svg";
export { ForwardRef as ReactComponent };